import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { messagesReducer } from './message-reducer';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature('messages', messagesReducer)],
})
export class MessageStoreModule {}
